var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavbarProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M2.5 1.75H12.5V8H2.5V1.75ZM12.5 9.25C12.8315 9.25 13.1495 9.1183 13.3839 8.88388C13.6183 8.64946 13.75 8.33152 13.75 8V1.75C13.75 1.05625 13.1875 0.5 12.5 0.5H2.5C1.80625 0.5 1.25 1.05625 1.25 1.75V8C1.25 8.33152 1.3817 8.64946 1.61612 8.88388C1.85054 9.1183 2.16848 9.25 2.5 9.25H0V10.5H15V9.25H12.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarProject);
export default __webpack_public_path__ + "static/media/navbar-project.10260b02.svg";
export { ForwardRef as ReactComponent };